import React, { useState, useEffect, createContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import './Stripe.css';
import CheckoutForm from './CheckoutForm';
import { Fetch } from "../services/dataservice";

export const PaymentContext = createContext(null);

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);

function CardDetails(props) {
    const [paymentRequest, setPaymentRequest] = useState({
        memberID: props.currentPayment.memberID,
        gcid: props.currentPayment.gcid,
        termPlan: props.currentPayment.termPlan
    });
    const [paymentIntentRequest, setPaymentIntentRequest] = useState({
        amount: props.currentPayment.amount,
        paymentDescriptor: props.currentPayment.paymentDescriptor        
    });
    const [csMessage, setCSMessage] = useState(null);
    const [clientSecret, setClientSecret] = useState('');

    useEffect(() => {
        // Create PaymentIntent as soon as the page loads
        (async () => {
            const response = await Fetch(`/Payment/CreatePaymentIntent`, "post", paymentIntentRequest);            
            setClientSecret(response.client_secret);
            if (!response.client_secret) {
                setCSMessage('An unexpected error occurred.');
            }
        })();

        return () => {
            // this now gets called when the component unmounts            
        };
    }, []);

    const appearance = {
        theme: 'stripe',    // 'night'
        labels: 'floating'
    };
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <PaymentContext.Provider value={paymentRequest}>
            <div>
                <div class="form-group">
                    <h3 style={{ color: "#fff", width: "100%", textAlign: "center" }}>Card Details</h3>
                </div>
                <div class="col-md-12 form-group" style={{ color: '#fff', fontSize: '18px' }}>
                    Amount: <span style={{ color: '#EF5030' }}>${paymentIntentRequest.amount}</span>
                </div>
                <div class="col-md-12 form-group">
                    {clientSecret ? (
                        <Elements options={options} stripe={stripePromise}>
                            <CheckoutForm />
                            {/* for testing card no.
                            4242424242424242 Payment succeeds
                            4000002500003155 Payment requires authentication
                            4000000000009995 Payment is declined for insufficient funds */}
                        </Elements>
                    ) : (
                        <>                        
                            <p style={{ marginTop: '10px', marginLeft: '275px' }}><i class="fa fa-spinner fa-spin" style={{ fontSize: '40px', color: '#fff' }}></i></p>
                            <div id="payment-message">{csMessage}</div>
                        </>
                    )}
                </div>
            </div>
        </PaymentContext.Provider>
    )
}

export default CardDetails;